import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-receivable-detail',
  templateUrl: './receivable-detail.component.html',
  styleUrls: ['./receivable-detail.component.css']
})
export class ReceivableDetailComponent implements OnInit {

  admin_data: any;
  d_interest = 7.5
  //part ข้อมูล
  data_debt: any; //ข้อมูลจากรายการลูกหนี้โครงการ
  all_debt: any; //ข้อมูลทั้งหมดจากตาราง m_receivabledetail ที่มีสถานะ Enable
  debt: any; //ข้อมูลที่ project_key ตรงกับ project_key ของรายการลูกหนี้โครงการ
  action_data: any = '';
  form_addData!: FormGroup;
  manager_types = ['สมาคม (โครงการในพื้นที่เป้าหมาย)', 'สมาคม (โครงการนอกพื้นที่เป้าหมาย)', 'องค์กรปกครองส่วนท้องถิ่น', 'การเคหะแห่งชาติ', 'กรมโยธาธิการและผังเมือง', 'หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน', 'หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง']
  gp = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  form_addPrinciple = [] as any;
  sum_addPrinciple = { interest: 0, sum: 0, err_interest: 0 }
  sumPrinciple: number = 9999;
  //part ตาราง
  debt_table: any;
  enableAdd: boolean = false;
  form_addTable!: FormGroup;
  enableEdit: boolean = false;
  enableEditIndex!: null;
  conclude = {
    loan_amount: 0,
    debt_capital: 0,
    debt_interest: 0,
    debt_return: 0,
    debt_all: 0,
    balance: 0
  }
  maximized: boolean = false;
  approve_status: boolean = false;
  appEdit_status: boolean = false;
  approve_new = {
    approve: '',
    agree: ''
  }
  approve = [] as any;
  durations = {
    year: 0,
    month: 0
  }
  paydate_status: boolean = false;
  paydEdit_status: boolean = false;
  paydate_new = {
    date: '',
    amount: ''
  }
  paydate = [] as any;
  int_cal = [] as any;
  bursary_type = {
    type: '',
    durations: { year: 0, month: 0 },
    date: '',
    date_th: '',
    remark: ''
  }
  bursary_status: boolean = false;
  num_col: any = 8;

  arr_installment = [] as any;
  constructor(
    public services: ApiService,
    public formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    document.getElementById('receivables')!.classList.toggle("active");
    document.getElementById('receivable')!.classList.toggle("show");
    document.getElementById('control')!.classList.toggle("active");

    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    this.data_debt = localStorage.getItem("debt");
    this.data_debt = JSON.parse(this.data_debt);

    if (this.data_debt.type_money == 'เงินอุดหนุน') {
      this.sumPrinciple = 0
      this.num_col = 9
    }
    this.getAllData();
    this.form_addData = this.formBuilder.group({
      debt_id: '',
      debt_name: '',
      project_name: this.data_debt.project_name,
      date_approve: '',
      objective: '',
      date_agree: '',
      amount_receive: '',
      duration: '',
      interest_rate: '',
      debt_pay: '',
      first_pay: '',
      final_pay: '',
      notify_amount: '',
      type_money: this.data_debt.type_money,
      project_key: this.data_debt.project_key,
      project_id: this.data_debt.project_id,
      short_term: '',
      long_term: '',
      form_addData: '',
      fiscal_year: this.data_debt.fund_year,
      manager_type: '',
      gp_principle: '',
      gp_interest: '',
      principle: '',
      user_id: Number(this.admin_data.id)
    });
  }

  ngOnDestroy() {
    document.getElementById('receivables')!.classList.remove("active");
    document.getElementById('receivable')!.classList.remove("show");
    document.getElementById('control')!.classList.remove("active");
  }

  //part detail(top)
  async getAllData() {
    await this.services.get("m_receivabledetail").then((res: any) => {
      this.all_debt = res.filter((data: any) => {
        // data.duration = Number(data.duration)
        return data.status.toLowerCase().match('enable')
      })
    });
    this.debt = this.all_debt.find((res: any) => {
      return res.project_key.toLowerCase().match(this.data_debt.project_key.toLowerCase())
    })

    if (this.debt) {
      // this.debt = this.debt[0]
      if (!this.debt.short_term) {
        this.debt.short_term = 0
      }
      if (!this.debt.long_term) {
        this.debt.long_term = 0
      }
      this.debt.amount = Number(this.debt.short_term) + Number(this.debt.long_term)

      this.form_addData = this.formBuilder.group({
        debt_id: this.debt?.debt_id,
        debt_name: this.debt.debt_name,
        project_name: this.debt.project_name,
        date_approve: JSON.parse(this.debt.date_approve), //มติอนุมัติและสัญญาข้อตกลงวันที่
        objective: this.debt.objective,
        date_agree: this.debt.date_agree, //ระยะเวลาการผ่อนชำระ
        amount_receive: this.debt.amount_receive,
        duration: JSON.parse(this.debt.duration), //ระยะเวลากาารกู้ยืม ปี_เดือน_
        interest_rate: this.debt.interest_rate,
        debt_pay: JSON.parse(this.debt.debt_pay), //ประเภทเงินอุดหนุน
        first_pay: this.debt.first_pay,
        final_pay: this.debt.final_pay,
        notify_amount: JSON.parse(this.debt.notify_amount), //กำหนดการจ่ายเงินให้กู้
        type_money: this.debt.type_money,
        project_key: this.debt.project_key,
        project_id: this.debt.project_id,
        short_term: this.debt.short_term,
        long_term: this.debt.long_term,
        manager_type: this.debt.manager_type,
        gp_principle: this.debt.gp_principle,
        gp_interest: this.debt.gp_interest,
        fiscal_year: this.debt.fiscal_year,
        principle: JSON.parse(this.debt.principle), //เงินต้น วันคิดดอกเบี้ย กำหนดวันจ่ายดอกเบี้ย
        user_id: Number(this.admin_data.id),
        status: this.debt.status
      });
      if (this.debt.debt_pay) {
        this.bursary_type = JSON.parse(this.debt.debt_pay)
        if (this.bursary_type.type == 'อุดหนุนใช้คืน') {
          this.bursary_status = true
          this.bursary_type.date_th = this.dateThaiFormat(this.bursary_type.date)
          this.sumPrinciple = 9999
        }
      }
      if (this.debt.first_pay != '') {
        this.debt.first_pay = this.dateThaiFormat(this.debt.first_pay)
      }
      if (this.debt.final_pay != '') {
        this.debt.final_pay = this.dateThaiFormat(this.debt.final_pay)
      }

      await this.getTableList();

      if (this.debt.principle) {
        this.form_addPrinciple = JSON.parse(this.debt.principle)
        this.form_addPrinciple.forEach((e: any) => {
          e.date_debtTH = this.dateThaiFormat(e.date_debt)
          e.date_payTH = this.dateThaiFormat(e.date_pay)
          e.interest = Number(e.interest)
        })
        if (this.data_debt.type_money == 'เงินให้กู้ยืม') {
          this.calculate();
        } else if (this.data_debt.type_money == 'เงินอุดหนุน') {
          await this.cal_actualPay()
        }
      }
      if (this.debt.date_approve) {
        this.approve = JSON.parse(this.debt.date_approve)
        this.approve.forEach((e: any) => {
          e.agree_th = this.dateThaiFormat(e.agree)
        });
      }
      if (this.debt.duration) {
        this.durations = JSON.parse(this.debt.duration)
      }
      if (this.debt.notify_amount) {
        this.paydate = JSON.parse(this.debt.notify_amount)
      }

      this.form_addTable = this.formBuilder.group({
        debt_id: this.debt?.debt_id,
        loan_year: '',
        loan_installment: '',
        loan_date: '',
        loan_amount: '',
        loan_cheque: '',
        debt_paydate: '',
        debt_installment: '',
        debt_ktb: '',
        debt_cheque: '',
        debt_capital: '',
        debt_interest: '',
        debt_return: '',
        debt_all: '',
        err_interest: '',
        remark: '',
        type_money: this.data_debt.type_money,
        project_key: this.data_debt.project_key,
        project_id: this.data_debt.project_id,
        user_id: Number(this.admin_data.id),
        status: 'Enable'
      });

      if (this.debt.date_agree) {
        for (let i = 1; i <= Number(this.debt.date_agree); i++) {
          this.arr_installment.push(`งวดที่ ${i}`)
        }
      }
    }

  }
  async onClickSaveData() {

    this.action_data = '';
    if (this.form_addData.value.debt_id == '' || this.form_addData.value.debt_id == null) {
      this.form_addData.value.debt_id = 0
    }
    if (this.form_addData.value.amount_receive == '' || this.form_addData.value.amount_receive == null) {
      this.form_addData.value.amount_receive = 0
    }
    if (this.form_addData.value.short_term == '' || this.form_addData.value.short_term == null) {
      this.form_addData.value.short_term = 0
    }
    if (this.form_addData.value.long_term == '' || this.form_addData.value.long_term == null) {
      this.form_addData.value.long_term = 0
    }
    this.form_addData.value.date_approve = JSON.stringify(this.approve)
    this.form_addData.value.principle = JSON.stringify(this.form_addPrinciple)
    this.form_addData.value.duration = JSON.stringify(this.durations)
    this.form_addData.value.notify_amount = JSON.stringify(this.paydate)
    this.form_addData.value.debt_pay = JSON.stringify(this.bursary_type)

    Swal.fire({
      title: 'ยืนยันการเพิ่มข้อมูลโครงการ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: 'ไม่ใช่',
      showDenyButton: true
    }).then(async (res: any) => {
      if (res.isConfirmed == true) {
        await this.services.create('m_receivabledetail', this.form_addData.value).then((res: any) => {
          Swal.fire({
            title: 'เพิ่มข้อมูลโครงการสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          })
          this.getAllData();
          this.form_addData.reset();
        })
      } else {
        this.form_addData = this.formBuilder.group({
          debt_id: '',
          debt_name: '',
          project_name: '',
          date_approve: '',
          objective: '',
          date_agree: '',
          amount_receive: '',
          duration: '',
          interest_rate: '',
          debt_pay: '',
          first_pay: '',
          final_pay: '',
          notify_amount: '',
          type_money: this.data_debt.type_money,
          project_key: this.data_debt.project_key,
          project_id: this.data_debt.project_id,
          short_term: '',
          long_term: '',
          fiscal_year: this.data_debt.fund_year,
          manager_type: '',
          gp_principle: '',
          gp_interest: '',
          principle: '',
          user_id: Number(this.admin_data.id)
        });
        this.form_addPrinciple = []
        this.sumPrinciple = 9999
        this.appEdit_status = false
        this.paydEdit_status = false
      }
    })
  }
  async onClickUpdateData() {
    this.action_data = '';
    if (this.form_addData.value.debt_id == '' || this.form_addData.value.debt_id == null) {
      this.form_addData.value.debt_id = 0
    }
    if (this.form_addData.value.amount_receive == '' || this.form_addData.value.amount_receive == null) {
      this.form_addData.value.amount_receive = 0
    }
    if (this.form_addData.value.short_term == '' || this.form_addData.value.short_term == null) {
      this.form_addData.value.short_term = 0
    }
    if (this.form_addData.value.long_term == '' || this.form_addData.value.long_term == null) {
      this.form_addData.value.long_term = 0
    }

    this.form_addData.value.principle = JSON.stringify(this.form_addPrinciple)
    this.form_addData.value.date_approve = JSON.stringify(this.approve)
    this.form_addData.value.duration = JSON.stringify(this.durations)
    this.form_addData.value.notify_amount = JSON.stringify(this.paydate)
    this.form_addData.value.debt_pay = JSON.stringify(this.bursary_type)

    if (this.form_addPrinciple[this.form_addPrinciple.length - 1].remain == 0) {
      Swal.fire({
        title: 'ยืนยันการแก้ไขข้อมูลโครงการ',
        icon: 'warning',
        confirmButtonText: `ใช่`,
        denyButtonText: 'ไม่ใช่',
        showDenyButton: true
      }).then(async (res: any) => {
        if (res.isConfirmed == true) {
          await this.services.update('m_receivabledetail', Number(this.debt.id), this.form_addData.value).then((res: any) => {

            Swal.fire({
              title: 'แก้ไขข้อมูลโครงการสำเร็จ',
              icon: 'success',
              confirmButtonText: `ตกลง`,
              showConfirmButton: false,
              timer: 1500
            })
            this.getAllData();
            this.form_addData.reset();
          })
        } else {
          this.appEdit_status = false
          this.paydEdit_status = false
        }
      })
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'ไม่สามารถบันทึกการแก้ไขได้',
        text: 'เนื่องจากข้อมูลการชำระเงินต้น เงินต้นคงเหลืองวดสุดท้ายไม่เท่ากับ 0',
        showConfirmButton: false,
        timer: 3000
      })
    }

  }
  async onInputYear() {
    // this.form_addPrinciple = [];
    if (this.form_addPrinciple.length == 0) {
      if (this.form_addData.value.date_agree && this.form_addData.value.gp_principle && this.form_addData.value.amount_receive) {
        for (let i = 1; i <= Number(this.form_addData.value.date_agree); i++) {
          this.form_addPrinciple.push({
            year: i,
            date_debt: "",
            date_debtTH: "",
            date_pay: "",
            date_payTH: "",
            interest: "",
            principle: "",
            remain: "",
            sum: ""
          })
        }
      }
    } else {
      if (Number(this.form_addData.value.date_agree) > this.form_addPrinciple.length) {
        let diff_1 = Number(this.form_addData.value.date_agree) - this.form_addPrinciple.length
        for (let i = 1; i <= Number(diff_1); i++) {
          this.form_addPrinciple.push({
            year: Number(this.form_addPrinciple.length) + i,
            date_debt: "",
            date_debtTH: "",
            date_pay: "",
            date_payTH: "",
            interest: "",
            principle: "",
            remain: "",
            sum: ""
          })
        }
      } else if (Number(this.form_addData.value.date_agree) < this.form_addPrinciple.length) {
        let diff_2 = this.form_addPrinciple.length - Number(this.form_addData.value.date_agree)
        this.form_addPrinciple.splice(this.form_addPrinciple.length - diff_2, diff_2)
      }
    }
    this.form_addPrinciple = this.form_addPrinciple.sort((a: any, b: any) => (a.year < b.year) ? -1 : ((b.year < a.year) ? 1 : 0))
  }

  onClickClose() {
    this.action_data = '';
    this.sumPrinciple = 9999
    this.appEdit_status = false
    this.paydEdit_status = false
    this.form_addPrinciple = [] as any

    this.getAllData()
    // this.form_addData = this.formBuilder.group({
    //   debt_id: '',
    //   debt_name: '',
    //   project_name: '',
    //   date_approve: '',
    //   objective: '',
    //   date_agree: '',
    //   amount_receive: '',
    //   duration: '',
    //   interest_rate: '',
    //   debt_pay: '',
    //   first_pay: '',
    //   final_pay: '',
    //   notify_amount: '',
    //   type_money: this.data_debt.type_money,
    //   project_key: this.data_debt.project_key,
    //   project_id: this.data_debt.project_id,
    //   short_term: '',
    //   long_term: '',
    //   fiscal_year: this.data_debt.fund_year,
    //   manager_type: '',
    //   gp_principle: '',
    //   gp_interest: '',
    //   principle: '',
    //   user_id: Number(this.admin_data.id)
    // });
  }
  totalAmount() {
    if (!this.form_addData.value.short_term) {
      this.form_addData.value.short_term = 0
    }
    if (!this.form_addData.value.long_term) {
      this.form_addData.value.long_term = 0
    }
    this.debt.amount = Number(this.form_addData.value.short_term) + Number(this.form_addData.value.long_term)
  }
  onSelecct_type(type: any) {
    switch (type) {
      case 'สมาคม (โครงการในพื้นที่เป้าหมาย)': {
        this.form_addData.patchValue({
          interest_rate: 'MLR - 3.5'
        });
        break;
      }
      case 'สมาคม (โครงการนอกพื้นที่เป้าหมาย)': {
        this.form_addData.patchValue({
          interest_rate: 'MLR - 2'
        });
        break;
      }
      case 'องค์กรปกครองส่วนท้องถิ่น': {
        this.form_addData.patchValue({
          interest_rate: 'MLR - 3'
        });
        break;
      }
      case 'การเคหะแห่งชาติ': {
        this.form_addData.patchValue({
          interest_rate: 'MLR - 3'
        });
        break;
      }
      case 'กรมโยธาธิการและผังเมือง': {
        this.form_addData.patchValue({
          interest_rate: 'MLR - 3'
        });
        break;
      }
      case 'หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน': {
        this.form_addData.patchValue({
          interest_rate: 'MLR - 2'
        });
        break;
      }
      case 'หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง': {
        this.form_addData.patchValue({
          interest_rate: 'MLR - 2'
        });
        break;
      }
      default: {
        // console.log('selected not found');
        break;
      }
    }
  }
  approve_add(form: any) {
    this.approve_status = false
    form.value.agree_th = this.dateThaiFormat(form.value.agree)
    this.approve.push(form.value)
    form.reset();
  }
  approve_update(formApp: any) {
    this.appEdit_status = false
    this.approve.forEach((e: any) => {
      e.agree_th = this.dateThaiFormat(e.agree)
    });
  }
  approve_del(i: any) {
    this.approve.splice(i, 1)
  }
  paydate_add(form: any) {
    this.paydate_status = false
    form.value.date_th = this.dateThaiFormat(form.value.date)
    this.paydate.push(form.value)
    form.reset();
  }
  paydate_update(form: any) {
    this.paydEdit_status = false
    this.paydate.forEach((e: any) => {
      e.date_th = this.dateThaiFormat(e.date)
    });
  }
  paydate_del(i: any) {
    this.paydate.splice(i, 1)
  }
  bursary_change() {
    if (this.bursary_type.type == 'อุดหนุนใช้คืน') {
      this.bursary_status = true
    } else {
      this.bursary_status = false
      this.bursary_type = {
        type: 'อุดหนุนให้ขาด',
        durations: { year: 0, month: 0 },
        date: '',
        date_th: '',
        remark: ''
      }
    }
  }

  //part table(bottom)
  async getTableList() {
    let all_table: any
    await this.services.get("m_receivabletable").then((res: any) => {
      all_table = res.filter((data: any) => {
        return data.status.toLowerCase().match('enable')
      })
    });
    this.debt_table = all_table.filter((response: any) => {
      response.loan_date_th = ''
      response.debt_paydate_th = ''

      if (response.loan_date != '') {
        response.loan_date_th = this.dateThaiFormat(response.loan_date)
      }
      if (response.debt_paydate != '') {
        response.debt_paydate_th = this.dateThaiFormat(response.debt_paydate)
      }

      return response.project_key.match(this.debt.project_key)
    })
    this.debt_table = this.debt_table.sort((a: any, b: any) => (a.id < b.id) ? -1 : ((b.id < a.id) ? 1 : 0))

    this.conclude = {
      loan_amount: 0,
      debt_capital: 0,
      debt_interest: 0,
      debt_return: 0,
      debt_all: 0,
      balance: 0
    }
    this.debt_table.forEach((con: any) => {
      this.conclude.loan_amount += Number(con.loan_amount)
      this.conclude.debt_capital += Number(con.debt_capital)
      this.conclude.debt_interest += Number(con.debt_interest)
      this.conclude.debt_return += Number(con.debt_return)
      this.conclude.debt_all += Number(con.debt_all)
    });
    this.conclude.balance = this.conclude.loan_amount - this.conclude.debt_capital
    this.cal_actualPay()
  }
  //add list in table
  onClickCloseAdd() {
    this.enableAdd = false
    this.form_addTable = this.formBuilder.group({
      debt_id: this.debt?.debt_id,
      loan_year: '',
      loan_installment: '',
      loan_date: '',
      loan_amount: '',
      loan_cheque: '',
      debt_paydate: '',
      debt_installment: '',
      debt_ktb: '',
      debt_cheque: '',
      debt_capital: '',
      debt_interest: '',
      debt_return: '',
      debt_all: '',
      err_interest: '',
      remark: '',
      type_money: this.data_debt.type_money,
      project_key: this.data_debt.project_key,
      project_id: this.data_debt.project_id,
      user_id: Number(this.admin_data.id),
      status: 'Enable'
    });
  }
  async onClickSaveAdd() {
    if (this.form_addTable.value.loan_year == '' || this.form_addTable.value.loan_year == null) {
      this.form_addTable.value.loan_year = 0;
    }
    if (this.form_addTable.value.loan_amount == '' || this.form_addTable.value.loan_amount == null) {
      this.form_addTable.value.loan_amount = 0;
    }
    if (this.form_addTable.value.debt_capital == '' || this.form_addTable.value.debt_capital == null) {
      this.form_addTable.value.debt_capital = 0;
    }
    if (this.form_addTable.value.debt_interest == '' || this.form_addTable.value.debt_interest == null) {
      this.form_addTable.value.debt_interest = 0;
    }
    if (this.form_addTable.value.debt_all == '' || this.form_addTable.value.debt_all == null) {
      this.form_addTable.value.debt_all = 0;
    }

    if (this.form_addTable.value.loan_date == '' || this.form_addTable.value.loan_date == null) {
      this.form_addTable.value.loan_date == ''
    }
    if (this.form_addTable.value.debt_paydate == '' || this.form_addTable.value.debt_paydate == null) {
      this.form_addTable.value.debt_paydate == ''
    }
    if (this.form_addTable.value.err_interest != '' || this.form_addTable.value.err_interest != null) {
      this.form_addTable.value.err_interest = (this.form_addTable.value.err_interest).toString()
    }

    Swal.fire({
      title: 'ยืนยันการเพิ่มรายการทะเบียนคุมลูกหนี้',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: 'ไม่ใช่',
      showDenyButton: true
    }).then(async (res: any) => {
      if (res.isConfirmed == true) {
        await this.services.create('m_receivabletable', this.form_addTable.value).then((res: any) => {
          Swal.fire({
            title: 'แก้ไขรายการทะเบียนคุมโครงการสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`,
            showConfirmButton: false,
            timer: 1500
          })
          this.getTableList()
          this.enableAdd = false;
          this.form_addTable = this.formBuilder.group({
            debt_id: this.debt?.debt_id,
            loan_year: '',
            loan_installment: '',
            loan_date: '',
            loan_amount: '',
            loan_cheque: '',
            debt_paydate: '',
            debt_installment: '',
            debt_ktb: '',
            debt_cheque: '',
            debt_capital: '',
            debt_interest: '',
            debt_return: '',
            debt_all: '',
            err_interest: '',
            remark: '',
            type_money: this.data_debt.type_money,
            project_key: this.data_debt.project_key,
            project_id: this.data_debt.project_id,
            user_id: Number(this.admin_data.id),
            status: 'Enable'
          });
        })
      }
    })
  }
  //edit list in table
  async onClickEdit(data: any, i: any) {
    this.enableEdit = true;
    this.enableEditIndex = i;

    let err_bool: boolean = false
    if (data.err_interest == 'true') {
      err_bool = true
    }
    this.form_addTable = this.formBuilder.group({
      debt_id: data.debt_id,
      loan_year: data.loan_year,
      loan_installment: data.loan_installment,
      loan_date: data.loan_date,
      loan_amount: data.loan_amount,
      loan_cheque: data.loan_cheque,
      debt_paydate: data.debt_paydate,
      debt_installment: data.debt_installment,
      debt_ktb: data.debt_ktb,
      debt_cheque: data.debt_cheque,
      debt_capital: data.debt_capital,
      debt_interest: data.debt_interest,
      debt_return: Number(data.debt_return),
      debt_all: data.debt_all,
      err_interest: err_bool,
      remark: data.remark,
      type_money: data.type_money,
      project_key: data.project_key,
      project_id: data.project_id,
      user_id: Number(this.admin_data.id),
      status: data.status
    });
  }
  async onClickDelete(data: any) {
    data.status = "Disable"
    Swal.fire({
      title: 'ยืนยันการลบรายการทะเบียนคุมโครงการ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: 'ไม่ใช่',
      showDenyButton: true
    }).then(async (res: any) => {
      if (res.isConfirmed == true) {
        await this.services.update('m_receivabletable', Number(data.id), data).then((res: any) => {
          this.getTableList()
          Swal.fire({
            title: 'ลบรายการทะเบียนคุมโครงการสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          })
          this.onClickCloseEdit()
        })
      }
    })
  }
  async onClickSaveEdit(id: any) {
    this.form_addTable.value.debt_id = Number(this.form_addTable.value.debt_id)
    this.form_addTable.value.loan_year = Number(this.form_addTable.value.loan_year)
    this.form_addTable.value.loan_amount = Number(this.form_addTable.value.loan_amount)
    this.form_addTable.value.debt_capital = Number(this.form_addTable.value.debt_capital)
    this.form_addTable.value.debt_interest = Number(this.form_addTable.value.debt_interest)
    this.form_addTable.value.debt_all = Number(this.form_addTable.value.debt_all)
    if (this.form_addTable.value.err_interest != '' || this.form_addTable.value.err_interest != null) {
      this.form_addTable.value.err_interest = (this.form_addTable.value.err_interest).toString()
    }

    Swal.fire({
      title: 'ยืนยันการแก้ไขรายการทะเบียนคุมโครงการ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: 'ไม่ใช่',
      showDenyButton: true,
    }).then(async (res: any) => {
      if (res.isConfirmed == true) {
        await this.services.update('m_receivabletable', id, this.form_addTable.value).then((res: any) => {
          this.getTableList()
          Swal.fire({
            title: 'แก้ไขรายการทะเบียนคุมโครงการสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`,
            showConfirmButton: false,
            timer: 1500
          })
          this.onClickCloseEdit()
        })
      }
    })

  }
  onClickCloseEdit() {
    this.enableEditIndex = null;
    this.enableEdit = false;
    this.form_addTable = this.formBuilder.group({
      debt_id: this.debt?.debt_id,
      loan_year: '',
      loan_installment: '',
      loan_date: '',
      loan_amount: '',
      loan_cheque: '',
      debt_paydate: '',
      debt_installment: '',
      debt_ktb: '',
      debt_cheque: '',
      debt_capital: '',
      debt_interest: '',
      debt_return: '',
      debt_all: '',
      err_interest: '',
      remark: '',
      type_money: this.data_debt.type_money,
      project_key: this.data_debt.project_key,
      project_id: this.data_debt.project_id,
      user_id: Number(this.admin_data.id),
      status: 'Enable'
    });
  }
  input_debt() {
    const sum = Number(this.form_addTable.value.debt_capital) + Number(this.form_addTable.value.debt_interest) + Number(this.form_addTable.value.debt_return)
    this.form_addTable.patchValue({
      debt_all: Number(sum)
    });
  }

  //full page table
  maximizeorMinimize(table: any, btn: any) {
    this.services.maximizeorMinimize(table, btn, this.maximized)
    this.maximized = this.services.switchMaximize(this.maximized);
  }
  dateThaiFormat(date: any) {
    if (date) {
      return date = new Date(date).toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } else {
      return ''
    }
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  onClickListMenu() {
    document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    // document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');
  }

  async onAddPrinciple() {
    let principle = this.form_addData.value.amount_receive

    for (let i = 0; i < this.form_addPrinciple.length; i++) {
      principle = Number(Number(principle).toFixed(2)) - Number(Number(this.form_addPrinciple[i].principle).toFixed(2))
      this.form_addPrinciple[i].remain = Number(principle).toFixed(2)
      this.form_addPrinciple[i].date_debtTH = this.dateThaiFormat(this.form_addPrinciple[i].date_debt)
      this.form_addPrinciple[i].date_payTH = this.dateThaiFormat(this.form_addPrinciple[i].date_pay)

      this.sumPrinciple = this.form_addPrinciple[i].remain
    }
  }

  async calculate() {
    var numOfDay: any //จำนวนวันในแต่ละงวด
    var first_day: any
    var second_day: any
    var debt_day: any //วันครบกำหนดจ่าย
    var principle: any //จำนวนเงินต้นที่จ่ายแต่ละงวด
    let data_mlr: any; // อัตราดอกเบี้ยทั้งหมด
    let mlr: any //ดอกเบี้ย MLR
    let different_mlr: any //ส่วนต่างMLR
    var day_in_year: any //จำนวนวันในปี
    var interest: any //ดอกเบี้ย
    var sum_int: any = 0 //ผลรวมดอกเบี้ย

    var loan_ori: any //จำนวนเงินต้นทั้งหมด
    var date_start: any
    const data = [] as any
    this.sum_addPrinciple = { interest: 0, sum: 0, err_interest: 0 }

    await this.services.get('m_calconditions').then((res: any) => {
      data_mlr = res.sort((a: any, b: any) => (new Date(a.date_used) < new Date(b.date_used)) ? -1 : ((new Date(b.date_used) < new Date(a.date_used)) ? 1 : 0))
    })

    switch (this.debt.manager_type) {
      case 'สมาคม (โครงการในพื้นที่เป้าหมาย)': {
        different_mlr = 3.5
        break;
      }
      case 'สมาคม (โครงการนอกพื้นที่เป้าหมาย)': {
        different_mlr = 2
        break;
      }
      case 'องค์กรปกครองส่วนท้องถิ่น': {
        different_mlr = 3
        break;
      }
      case 'การเคหะแห่งชาติ': {
        different_mlr = 3
        break;
      }
      case 'กรมโยธาธิการและผังเมือง': {
        different_mlr = 3
        break;
      }
      case 'หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน': {
        different_mlr = 2
        break;
      }
      case 'หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง': {
        different_mlr = 2
        break;
      }
      default: {
        //statements; 
        break;
      }
    }
    //วันที่เริ่มคิดดอกเบี้ยและจำนวนเงิน งวดแรก
    for (let j = 0; j < this.paydate.length; j++) {
      if (j == 0) {
        date_start = this.paydate[j].date
        loan_ori = this.paydate[j].amount
      }
    }

    for (let i = 0; i < this.form_addPrinciple.length; i++) {

      if (i >= this.debt.gp_interest) { //พิจารณางวดที่ปลอดดอกเบี้ย
        //คำนวนจำนวนวันในแต่ละงวด
        if (i == 0) {
          first_day = date_start //วันแรกที่จ่ายเงินงวดแรก เป็นวันเริ่มต้นคิดดอก
          second_day = this.form_addPrinciple[i].date_debt //วันครบกำหนดคิดดอกเบี้ยงวดปัจจุบัน
          debt_day = this.form_addPrinciple[i].date_pay
          principle = this.form_addPrinciple[i].principle
        } else {
          var end = new DatePipe('en-US').transform(new Date((new Date(this.form_addPrinciple[i - 1].date_debt).setDate(new Date(this.form_addPrinciple[i - 1].date_debt).getDate() + 1))), 'yyyy-MM-dd')
          first_day = end //วันครบกำหนดคิดดอกเบี้ยงวดก่อนหน้า +1 เป็นวันเริ่มต้นคิดดอก
          second_day = this.form_addPrinciple[i].date_debt //วันครบกำหนดคิดดอกเบี้ยงวดปัจจุบัน
          debt_day = this.form_addPrinciple[i - 1].date_pay
          principle = this.form_addPrinciple[i - 1].principle
        }
        sum_int = 0
        numOfDay = this.difference_day(new Date(first_day!), new Date(second_day!)) + 1
        // console.log(`${i + 1} || ${numOfDay} || ${first_day} || ${second_day}`);

        //คำนวณดอกเบี้ยในแต่ละงวด
        for (let x = 1; x <= numOfDay; x++) {
          if (x == 1 && i == 0) { //check date
            first_day = new DatePipe('en-US').transform(new Date(date_start!), 'yyyy-MM-dd')
            second_day = new DatePipe('en-US').transform(new Date((new Date(first_day).setDate(new Date(first_day).getDate() + 1))), 'yyyy-MM-dd')
          } else if (x == 1) {
            first_day = first_day
            second_day = new DatePipe('en-US').transform(new Date((new Date(first_day).setDate(new Date(first_day).getDate() + 1))), 'yyyy-MM-dd')
          } else {
            first_day = second_day
            second_day = new DatePipe('en-US').transform(new Date(new Date(first_day).getFullYear(), new Date(first_day).getMonth(), new Date(first_day).getDate() + 1), 'yyyy-MM-dd');
          }
          //check mlr
          data_mlr.forEach(async (data: any, i: any) => {
            if (i == data_mlr.length - 1) {
              if (new Date(first_day!) >= new Date(data.date_used)) {
                mlr = Number(data.interest)
              }
            } else {
              if (new Date(first_day!) >= new Date(data.date_used) && new Date(first_day!) <= new Date(data_mlr[i + 1].date_used)) {
                mlr = Number(data.interest)
              }
            }
          });
          for (let y = 0; y < this.paydate.length; y++) { //check เงินต้นงวดต่างๆ *กรณีที่มีมากกว่า1งวด
            if (y > 0 && first_day == this.paydate[y].date) {
              loan_ori = Number(loan_ori) + Number(this.paydate[y].amount) //เงินต้นทั้งหมด
            }
          }

          if (first_day == debt_day) { //check pay debt วันที่ครบกำหนดชำระเงิน หากครบแล้วจะลดต้นตามจ่ายจริง
            loan_ori = Number(loan_ori) - Number(principle)
          }
          //หาจำนวนวันในปีที่คิดดอก
          day_in_year = await this.days_of_a_year(Number(new DatePipe('en-US').transform(new Date(first_day), 'yyyy')!))
          //คำนวณดอกเบี้ย
          interest = await (Number(loan_ori) * ((Number(mlr) - Number(different_mlr)) / 100)) * (this.difference_day(new Date(first_day!), new Date(second_day!)) / day_in_year)
          sum_int += Number((interest).toFixed(11))
          sum_int = Number((sum_int).toFixed(10))
          // if(i==6){
          // console.log(`${i + 1} || ${x} || ${first_day} || ${second_day} || ${mlr} || ${day_in_year} || ต้น ${loan_ori.toFixed(2)} || ดอก ${interest.toFixed(2)} || ${sum_int.toFixed(2)}`);
          // }
        }
        // console.log(`${Number(sum_int).toFixed(2)}`);
        data.push({ year: i + 1, int: Number(sum_int).toFixed(2) })
      }
    }
    this.int_cal = data

    this.form_addPrinciple.forEach((e: any, i: any) => {
      this.int_cal.forEach((el: any, j: any) => {
        if (e.year == el.year) {
          e.interest = el.int
          e.sum = Number(e.principle) + Number(e.interest)

        }
      });
    });
    await this.cal_actualPay()
  }
  async cal_actualPay() {
    let arr_debt = this.debt_table.filter((d: any) => { //หาข้อมูลการชำระหนี้
      return d.debt_paydate
    })
    this.form_addPrinciple.forEach((e: any, i: any) => {
      if (arr_debt) { //หาวันที่จ่ายจริง
        let pay_actual = arr_debt.find((d: any) => {
          return (d.debt_installment).split(' ')[1] == i + 1
        })
        if (pay_actual) {//มีวันที่จ่ายจริง
          e.date_actualPay = pay_actual.debt_paydate
          e.date_actualPayTH = this.dateThaiFormat(e.date_actualPay)
        } else {//ไม่มีวันที่จ่ายจริง
          e.date_actualPay = ''
          e.date_actualPayTH = ''
        }
      }
      if (e.date_actualPay) {
        if (new Date(e.date_actualPay) > new Date(e.date_pay)) {
          e.err__interest = (Number(this.debt?.amount_receive) * (this.d_interest / 100)) * ((this.difference_day(new Date(e.date_pay), new Date(e.date_actualPay)) - 1) / this.days_of_a_year(new Date(e.date_pay).getFullYear()))
        } else {
          e.err__interest = ''
        }
      } else {
        e.err__interest = ''
      }
    })

    this.sum_addPrinciple.err_interest = this.form_addPrinciple.reduce((a: any, b: any) => +a + +Number(b.err__interest), 0);
    this.sum_addPrinciple.interest = this.form_addPrinciple.reduce((a: any, b: any) => +a + +Number(b.interest), 0);
    this.sum_addPrinciple.sum = this.form_addPrinciple.reduce((a: any, b: any) => +a + +Number(b.sum), 0);
  }
  //นับจำนวนวันในปี
  days_of_a_year(year: number) {
    return this.isLeapYear(year) ? 366 : 365;
  }
  isLeapYear(year: number) {
    return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
  }
  //คำนวณจำนวนวันที่ต่าง
  difference_day(day1: any, day2: any) {
    var difference_In_Time = day2.getTime() - day1.getTime();
    var difference_In_Days = (difference_In_Time / (1000 * 3600 * 24));
    return difference_In_Days
  }
  //ปัดทศนิยม
  mathRound(num: number) {
    return Math.round((num + Number.EPSILON) * 100) / 100
  }
}
